// extracted by mini-css-extract-plugin
export default {"wrapper":"N1-z","message":"O1-z","image":"P1-z"};